import { Alert, AlertTitle, Box, Button, ButtonProps, Modal, Typography, IconButton } from "@mui/material"
import { Close as CloseIcon } from '@mui/icons-material'
import { schemas } from "../generated/api/client"
import { z } from "zod"
import { apiClient, apiClientHooks } from "../bootstrapping/InitApiClient"
import { queryClient } from "../bootstrapping/InitReactQuery"
import { useState } from "react"

type EBulkApplication = z.infer<typeof schemas.EBulkApplication>

const RestartApplicationButton: React.FC<{ dbsApp: EBulkApplication } & Omit<ButtonProps, 'onclick'>> = ({ dbsApp, children, ...buttonProps }) => {
  const restartableStatuses: Array<typeof dbsApp.status> = [
    'rejected',
  ]
  const hasCorrectStatus = restartableStatuses.includes(dbsApp.status)

  const restartableMyEBulkApplicationByID = apiClientHooks.useRestartableMyEBulkApplicationByID({
    params: { id: dbsApp.id },
   }, {
    enabled: hasCorrectStatus,
   })

  const isRestartable = restartableMyEBulkApplicationByID.data?.isRestartable
  return isRestartable === true
    ? <ConfirmedRestartApplicationButton dbsApp={dbsApp} {...buttonProps}>{children}</ConfirmedRestartApplicationButton>
    : null
}

const ConfirmedRestartApplicationButton: React.FC<{ dbsApp: EBulkApplication } & Omit<ButtonProps, 'onclick'>> = ({ dbsApp, children, ...buttonProps }) =>  {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  return <>
      <Button {...buttonProps} onClick={handleOpen}>{children}</Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ mb: 2 }}>
            Restart Application
          </Typography>
          <Alert severity="info" sx={{ mb: 2 }}>
            <AlertTitle>Are you sure?</AlertTitle>
            This action will reinvite you to the same Job Role, so you can restart a new application.
          </Alert>
          <Button
            variant="contained"
            color="success"
            onClick={async () => {
              await apiClient.restartMyEBulkApplicationByID(undefined, { params: { id: dbsApp.id } })
              queryClient.invalidateQueries({ queryKey: apiClientHooks.getKeyByAlias('getMyEBulkApplications') })
              queryClient.invalidateQueries({ queryKey: apiClientHooks.getKeyByAlias('getMyInvites') })
              setOpen(false)
            }}
            sx={{ mt: 2 }}
          >
            Restart my Application
          </Button>
          <Button
            variant="text"
            color="primary"
            onClick={handleClose}
            sx={{ ml: 3, mt: 2 }}
          >
            Cancel
          </Button>
        </Box>
      </Modal>
    </>
}

export default RestartApplicationButton
